// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b7d66a4a","104":"81b82065","228":"ce06667f"}[chunkId] + ".chunk.js";
};